import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import VueOffline from 'vue-offline';
import VueRouter from 'vue-router'
import './plugins/bootstrap-vue'
import App from './App.vue'
import routes from './router'
import store from './store'

Vue.use(VueOffline);
Vue.use(VueRouter);

Vue.config.productionTip = false

const router = new VueRouter({
  routes
})

new Vue({
  router,
  store,
  data: {},
  render: h => h(App)
}).$mount('#app')
